    <div class="h-full w-full si-card">
        <div class="flex flex-row grow-0 border-b px-4 py-2">
            <div class="flex grow items-center">
                <h3 class="pt-2 whitespace-nowrap">Intent</h3>
            </div>
            <ng-container *ngIf="(intentAgentsSetup$ | async) as agentsList">
            <div class="flex grow-0 items-center" *ngIf="agentsList.length !== 0">
                <button matButton="outlined" type="button" [matTooltip]="selectedOption?.name || 'All Agents'"
                    class="mat-small-button mr-1 card-menu si-menu-trigger"
                    [matMenuTriggerFor]="intentAgentsMenu">
                    <span class="si-card-menu-content">
                        <span class="si-card-menu-label">{{ selectedOption?.name || 'All Agents' }}</span>
                        <span class="si-menu-trigger-icon" aria-hidden="true"></span>
                    </span>
                </button>
                <mat-menu #intentAgentsMenu>
                    <ng-template matMenuContent>
                        <button mat-menu-item (click)="updateSelectedOption(null)">
                            All Agents
                        </button>
                        <button mat-menu-item *ngFor="let agent of agentsList" (click)="updateSelectedOption(agent)">
                            {{agent.name}}
                        </button>
                    </ng-template>
                </mat-menu>
                <mat-button-toggle-group name="type" class="mr-1 card-toggle-btn">
                    <mat-button-toggle value="CHART" [checked]="isShowChart" (click)="isShowChart = true" class="flex items-center">
                        <fa-icon matTooltip="Chart" class="si-icon" [icon]="['fal', 'chart-column']"></fa-icon>
                    </mat-button-toggle>
                    <mat-button-toggle value="TABLE" [checked]="!isShowChart" (click)="isShowChart = false" class="flex items-center">
                        <fa-icon matTooltip="Table" class="si-icon" [icon]="['fal', 'table']"></fa-icon>
                    </mat-button-toggle>
                </mat-button-toggle-group>
              <div [matTooltip]="!selectedOption ? 'View all only available when an individual Intent Agent is selected.': ''">
                <button matButton="outlined" type="button" class="mat-small-button card-btn" [disabled]="!selectedOption || isWeeklyAgentsNotRun" (click)="showReport()">
                  View All
                </button>
              </div>
            </div>
            </ng-container>
        </div>

        <div *ngIf="(isIntentLoading$ | async); else showIntentDetails" class="flex justify-center items-center h-full w-full">
            <mat-spinner></mat-spinner>
        </div>
        <ng-template #showIntentDetails>
        <ng-container *ngIf="topicsPredictiveIntent$ | async as topicsPredictiveIntent">
            <ng-container *ngIf="topicsBombora$ | async as topicsBombora">
                <ng-container *ngIf="(topicsPredictiveIntent?.length === 0 && topicsBombora?.length === 0); else checkAgent">
                    <div class="h-full w-full p-4 content-center text-center font-bold">
                        <p class="card-info pb-1 px-2">Set up Intent Topics and get fresh intent data delivered
                            to your CRM and inbox each week with intent agents.</p>
                        <button matButton="filled" (click)="onOpenIntentSettings()"> Get Started Now </button>
                    </div>
                </ng-container>
                <ng-template #checkAgent>
                    <ng-container *ngIf="(intentAgentsSetup$ | async)?.length === 0; else showAgentData">
                        <app-intent-surge class="flex flex-col h-full overflow-auto" [topicsPredictiveIntent]="topicsPredictiveIntent" [topicsBombora]="topicsBombora" [surgeCount]="surgeCount$ | async" [isLoading]="isSurgeCountLoading$ | async" [isAdmin]="(isAdmin$ | async) || ('is_ops_admin' | userDataByKey | async)" [adminEmail]="adminEmailIds$ | async"
                            (searchTrigger)="navigateToSearch($event)"></app-intent-surge>
                    </ng-container>
                </ng-template>
            </ng-container>
        </ng-container>
        </ng-template>
    </div>

<ng-template #showAgentData>
    <div class="flex flex-col h-full w-full p-4 relative overflow-hidden">
    <ng-container *ngIf="selectedOption; else combinedData">
        <div class="flex flex-col h-full" *ngIf="selectedOption?.email_only; else nonEmail">
            <ng-container *ngIf="!isWeeklyAgentsNotRun; then emailOnlyReport; else notRun"></ng-container>
        </div>
    </ng-container>
    </div>
    <ng-template #nonEmail>
        <ng-container *ngIf="isWeeklyAgentsNotRun then notRun else showexportGraphAndTable"></ng-container>

    </ng-template>
    <ng-template #combinedData>
        <ng-container *ngIf="!isWeeklyAgentsNotRun else notRun">
            <ng-container *ngIf="isAllAgentsEmailOnly; then emailOnlyReport"></ng-container>
            <ng-container *ngIf="isAllAgentsExportOnly; then showexportGraphAndTable"></ng-container>
            <ng-container *ngIf="!isAllAgentsEmailOnly && !isAllAgentsExportOnly; then showCombinedGraphAndTable"></ng-container>
        </ng-container>
        <ng-template #showCombinedGraphAndTable>
        <p class="card-sub-header-text">All Intent Agent activity over the past 4 weeks</p>
        <div class="flex flex-col h-full w-full overflow-hidden" *ngIf="isShowChart; else combinedTable">
            <app-line-chart class="flex flex-col w-full h-full" [chartData]="chartData" [chartLabels]="chartLabels" legendKeyToHide="All Companies"></app-line-chart>
        </div>
        </ng-template>
    </ng-template>
    <ng-template #notRun>
        <div class="h-full w-full p-4 content-center text-center font-bold" *ngIf="!(isSurgedCompaniesLoading$ | async)">
            <div class="card-info pb-4">This agent hasn’t run yet, so we don’t have any data to show you. Use the
                button below to manually run your agent.</div>
            <button matButton="filled" (click)="runAgent()">Run Agent</button>
        </div>
    </ng-template>
</ng-template>

<ng-template #barChart>
    <div class="chart-container h-full">
        <app-bar-chart [chartLabels]="chartLabels" [chartData]="barChartData" [showDataLabel]="true"
            [showHorizontalGridLines]="true" [showTooltips]="false" [useAbbreviationYAxis]="true"></app-bar-chart>
    </div>
</ng-template>

<ng-template #exportTable>
    <div class="table-container">
        <app-data-table [data]="intentTableData" [columns]="exportColumns" sortActive="displayDate" sortDirection="asc"
            smallRowHeight="true" [layoutFixed]="false">
        </app-data-table>
    </div>
</ng-template>

<ng-template #reportTable>
    <div class="table-container">
        <app-data-table [data]="intentTableData" [columns]="reportColumns" sortActive="displayDate" sortDirection="asc"
            smallRowHeight="true" [layoutFixed]="false">
        </app-data-table>
    </div>
</ng-template>

<ng-template #combinedTable>
    <div class="table-container">
        <app-data-table [data]="intentTableData" [columns]="combinedColumns" sortActive="displayDate" sortDirection="asc"
            smallRowHeight="true" [layoutFixed]="false">
        </app-data-table>
    </div>
</ng-template>

<ng-template #emailOnlyReport>
    <p class="card-sub-header-text">Companies surging over the past 4 weeks</p>
    <ng-container *ngIf="isShowChart; then barChart; else reportTable"></ng-container>
</ng-template>

<ng-template #showexportGraphAndTable>
    <p class="card-sub-header-text">Companies and contacts exported over the past 4 weeks</p>
    <div class="flex flex-col h-full w-full overflow-hidden" *ngIf="isShowChart; else exportTable">
        <app-line-chart class="flex flex-col w-full h-full" [chartData]="chartData" [chartLabels]="chartLabels"></app-line-chart>
    </div>
</ng-template>
